class Geolocator extends HTMLElement {
  constructor() {
    super();

    this.location = this.dataset.location || '/pages/store-locator';
    this.selector = document.getElementById('geolocation-content');
    this.locationWrapper = document.getElementById('geolocation-content');
    this.showAll = this.handleShowMoreClick.bind(this);
    this.data;

    let geolocatorObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let elem = entry.target;
            if (entry.intersectionRatio >= 0) {
              //disconnect because it is shown
              observer.disconnect();
              this.fetchCurrentLocation();
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '500px 0px',
        threshold: 0,
      }
    );
    window.addEventListener('load', () => {
      let observedEl = this.dataset.el || '.geolocation-wrapper';
      geolocatorObserver.observe(document.querySelector(observedEl));
      this.selector.innerHTML = 'Loading...';
    });
  }

  handleShowMoreClick() {
    this.locationWrapper.innerHTML = '';

    const locationData = this.data;

    const nodes = locationData.map((location) => {
      let div = document.createElement('div');

      div.innerHTML = this.renderLocation(location, this.cf_response);

      div.style.width = '100%';

      return div;
    });

    this.locationWrapper.append(...nodes);
    
    // Click Tracking
    hpcGeolocatorClicks();
    
    let link = document.createElement('div');
    link.innerHTML = `<a style="font-size: 13.333px; color: white; text-decoration: underline;" href="${this.location}">View all locations</a>`;
    link.classList.add('location-btn-container');
    link.style.textAlign = "center";

    // Click Tracking
    let params = {
      'section': 'Geolocator',
      'element': 'View all',
      'element_text': link.textContent.trim(),
      'url': this.location,
    };

    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.hpc.hpcDataPush(params);
      window.location.href = params.url;
    });

    this.locationWrapper.parentElement.append(link);

    new Flickity('#geolocation-content', {
      wrapAround: true,
      pageDots: false,
    });
  }

  fetchCurrentLocation() {
    const this_geolocator = this;
    fetch("https://geolocator-v2.janeiredale.workers.dev/",
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(function (response) {
      // console.log('cloudflare response',response);
      if (response.ok) {
        return response.json();
      }
    })
    .then(function (cf_response) {
      // console.log('cloudflare locations',cf_response);

      $.ajax({
        url: "https://stockist.co/api/v1/u6148/locations/search",
        // Search parameters
        data: {
          latitude: cf_response.latitude,
          longitude: cf_response.longitude,
          distance: 25,
          filters: [5611]
      },
        dataType: "jsonp",
        success: function(response) {
          // console.log('stockists success response', response);
          this_geolocator.render(response.locations, cf_response);
        },
        error: function(response) {
          console.log('stockists error response', response);
        }
      });
    })
    .catch(function (error) {
      console.error("Error retreiving geolocation: ", error);
    });

  }

  renderLocation(location, cf_response) {
    const {
      name,
      state,
      city,
      postal_code,
      address_line_1,
      phone,
      website,
      webdisplay,
      latitude,
      longitude,
    } = location;

    // console.log('location',location);

    let link_text = '';
    if (website) {
      link_text = website.replace('https://', '');
      link_text = link_text.replace('http://', '');
    }

    let html = `
      <p>${name}</p>
      <p>${address_line_1}</p>
      <p>${city}, ${state} ${postal_code}</p>
      ${phone ? `<p><a style="color: white;" href="tel:${phone}">${phone}</a></p>` : ''}
      ${website ? `<p><a style="color: white;" href="${website}" target="_blank">${link_text}</a></p>` : ''}
      <a style="color: white; text-decoration: underline;" target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${cf_response.latitude},${cf_response.longitude}&destination=${latitude},${longitude}">Directions</a>
    `;

    return html;
  }

  render(data, cf_response) {
    if (data.length && cf_response.latitude.length) {
      let location = data[0];
      const showMore = data.length > 1;
      this.selector.innerHTML = this.renderLocation(location, cf_response);

      if (showMore) {
        let div = document.createElement('div');
        div.innerHTML = `<button id="stores-located-view-all">View more locations</button>`;
        div.classList.add('location-btn-container');
        this.locationWrapper.append(div);
        this.data = data;
        this.cf_response = cf_response;

        let view_all = document.getElementById('stores-located-view-all');
        view_all.addEventListener('click', this.showAll);

        // Click Tracking
        let params = {
          'section': 'Geolocator',
          'element': 'View more',
          'element_text': view_all.textContent.trim(),
          'url': 'none',
        };

        view_all.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.hpc.hpcDataPush(params);
        });
      } else {
        let div = document.createElement('div');
        div.innerHTML = `<a style="color: white; text-decoration: underline;" href="${this.location}">View all locations</a>`;
        div.classList.add('location-btn-container');
        this.locationWrapper.append(div);
      }
    } else {
      this.selector.innerHTML = `<a style="color: white; text-decoration: underline;" href="${this.location}">Find a store near you</a>`;
    }

    // Click Tracking
    hpcGeolocatorClicks();
  }
}
function hpcGeolocatorClicks() {
  // Click Tracking
  let links = document.querySelectorAll('#geolocation-content a');
  links.forEach((elem) => {
    let text_container = elem.closest('div').querySelector('p');
    let text_content = text_container.textContent.trim();
    let url = elem.getAttribute('href');
    let params = {
      'section': 'Geolocator',
      'element': 'Website',
      'element_text': text_content.substring(0,99),
      'url': url,
    };

    if (url.includes('tel:')) {
      params.element = 'Telephone';
    } else if (url.includes('google.com/maps')) {
      params.element = 'Directions';
    } else {

    }

    elem.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // console.log(params);
      window.hpc.hpcDataPush(params);
      
      window.open(params.url,'_blank');
      // window.location.href = params.url;
    });
  });
}
customElements.define('geolocator-ip', Geolocator);
